import PropTypes from "prop-types";
import { labelPropType, disabledPropType, classNamePropType, onCheckedPropType } from "../../common";

/**
 * PropTypes for Toggle component
 *
 * @property {boolean} [checked] - Toggle state (on/off)
 * @property {function} [onChecked] - Change handler callback - receives new boolean value
 * @property {boolean} [disabled] - Disable toggle interaction
 * @property {string} [label] - Label text displayed next to toggle
 * @property {string} [className] - Additional CSS classes
 */
export const togglePropTypes = {
  checked: PropTypes.bool,
  onChecked: onCheckedPropType,
  disabled: disabledPropType,
  label: labelPropType,
  className: classNamePropType,
};
